import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	country: null,
	error: "",
	loading: false,
};

// ADD_state
export const addCountry = createAsyncThunk(
	"state/addCountry",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `country/`,
				data: {
					...values,
				},
			});
			toast.success("Country added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Country try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_country
export const deleteCountry = createAsyncThunk(
	"country/deleteCountry ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `country/${id}`,
			});

			toast.success("Country deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Country try again");
			console.log(error.message);
		}
	}
);

// countryS
export const getAllCountry = createAsyncThunk(
	"country/getAllCountry",
	async () => {
		try {
			const { data } = await axios.get(`country/`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateCountry = createAsyncThunk(
	"country/updateCountry",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `country/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Country updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Country try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const countrySlice = createSlice({
	name: "country",
	initialState,
	reducers: {
		clearCountry: (state) => {
			state.country = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllCountry ======

		builder.addCase(getAllCountry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllCountry.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllCountry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addCountry  ======

		builder.addCase(addCountry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addCountry.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addCountry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for state ======

		builder.addCase(updateCountry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateCountry.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateCountry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteCountry  ======

		builder.addCase(deleteCountry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteCountry.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteCountry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default countrySlice.reducer;
export const { clearCountry } = countrySlice.actions;
